import { useState } from "react";
import { CommandPalette } from "@client/components/CommandPalette";

/**
 * What is left of the desktop top bar: the command palette, opened with ⌘K / Ctrl+K.
 *
 * The bar itself is gone (design pass, Alex, 22/10). Its search field was the palette's only
 * visible door, and the account menu beside it moved to the bottom of the sidebar
 * (`Sidebar.tsx`, `SidebarAccount`), so the bar had become a 64px strip with nothing in it on every
 * page. The palette stays mounted here, outside the sidebar, so the shortcut works everywhere —
 * including on a phone with a hardware keyboard.
 */
export function AppHeader() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  return <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />;
}
